<template>
    <div class="poca-player-wrapper">
        <div v-if="hidden" class="hidden-poca-player">
            <div class="player-toggler px-2 pt-2" v-on:click="toggleHidden">
                <span class="mt-2" v-if="isPlaying">
                    <i class="fa fa-play"></i> {{ currentSong.name }} | {{ getCurrentTime() }} / {{ getDuration() }}
                </span>
                <span v-if="!isPlaying && hidden">
                    PocaRadio {{ getIcon() }}
                </span>
            </div>
        </div>
        <div v-if="!hidden && playerInstance" class="poca-music-player">
            <div class="row p-0">
                <div class="col-12 px-0 d-flex justify-content-between">
                    <h5 class="pt-2">PocaRadio {{ getIcon() }}</h5>
                    <div class="p-1 play-time">
                        {{ getCurrentTime() }} / {{ getDuration() }}
                    </div>
                    <a class="btn btn-secondary px-3 py-1" v-on:click="toggleHidden">
                        Hide
                    </a>
                </div>
                <div class="col-12 px-0 d-flex justify-content-between">
                    <div>
                        <a class="btn btn-secondary px-3 py-1" v-on:click="previousSong">
                            <i class="fa fa-backward-step"></i>
                        </a>
                        <a class="btn btn-secondary px-3 py-1" v-on:click="togglePlay()">
                            <i :class="isPlaying ? 'fa fa-pause' : 'fa fa-play'"></i>
                        </a>
                        <a class="btn btn-secondary px-3 py-1" v-on:click="nextSong">
                            <i class="fa fa-forward-step"></i>
                        </a>
                    </div>
                    <input v-if="playerInstance" type="range" min="0.01" max="1" step="0.01" v-model="this.playerInstance.volume">
                </div>
                <div class="col-12 px-0">
                    <select class="mt-2 form-control form-control-sm" name="playlist" id="playlist" v-model="selectedPlaylistIndex">
                        <option v-for="(playlist, playlistIndex) in enabledPlaylists" :value="playlistIndex">
                            {{ selectedPlaylistIndex === playlistIndex ? 'Current Playlist: ' : '' }}{{ playlist.name }}
                        </option>
                    </select>
                    <span class="mt-2" v-text="currentSongInfo"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "MusicPlayer",
    props: {
        preSelectedPlaylist: Number
    },
    data() {
        return {
            hidden: true,
            playerInstance: null,
            isPlaying: false,
            selectedPlaylistIndex: 0,
            activePlaylist: null,
            currentSongIndex: 0,
            playLists: [
                {
                    name: 'Halloween',
                    enabled: true,
                    songs: [
                        {
                            name: 'Lavender Town',
                            artist: 'Qumu',
                            src: '/assets/dipocaco/sounds/lavender_town.mp3',
                        },
                        {
                            name: 'Ghost Pokémon',
                            artist: 'Jose B. Rebelledo Animation',
                            src: '/assets/dipocaco/sounds/music/halloween/ghost_pokemon_halloween_2023.mp3',
                        },
                        {
                            name: 'Marnie Battle Theme',
                            artist: 'Pokémon Sword & Shield',
                            src: '/assets/dipocaco/sounds/music/halloween/Pokémon Sword & Shield - Marnie Battle Music (HQ).mp3',
                        },
                        {
                            name: 'Cynthia Battle Theme',
                            artist: 'Pokémon Diamond, Pearl & Platinum',
                            src: '/assets/dipocaco/sounds/music/halloween/Pokémon Diamond, Pearl & Platinum - Champion Cynthia Battle Music (HQ).mp3',
                        },
                        {
                            name: 'Gym Leader Battle Theme',
                            artist: 'Pokémon Sword & Shield',
                            src: '/assets/dipocaco/sounds/music/halloween/Pokémon Sword & Shield OST - Gym Leader Battle (Full In-Game Version).mp3',
                        },
                    ]
                },
                {
                    name: 'Movies',
                    enabled: true,
                    songs: [
                        {
                            name: 'Pokémon The First Movie - Vacation',
                            artist: 'Pokémon The First Movie Soundtrack',
                            src: '/assets/dipocaco/sounds/music/movies_ost/Pokémon The First Movie - Vacation.mp3',
                        },
                        {
                            name: 'Birth of Mewtwo (Expanded)',
                            artist: 'Pokémon The First Movie Soundtrack',
                            src: '/assets/dipocaco/sounds/music/movies_ost/Pokémon The First Movie Soundtrack_ 01 - Birth of Mewtwo (Expanded).mp3',
                        },
                        {
                            name: 'Dragonite Takes Flight',
                            artist: 'Pokémon The First Movie Soundtrack',
                            src: '/assets/dipocaco/sounds/music/movies_ost/Pokémon The First Movie Soundtrack_ 03 - Dragonite Takes Flight.mp3',
                        },
                        {
                            name: 'This Is My World Now',
                            artist: 'Pokémon The First Movie Soundtrack',
                            src: '/assets/dipocaco/sounds/music/movies_ost/Pokémon The First Movie Soundtrack_ 11 - This is my World Now.mp3',
                        },
                        {
                            name: 'Brother My Brother',
                            artist: 'Pokémon The First Movie Soundtrack',
                            src: '/assets/dipocaco/sounds/music/movies_ost/Pokémon The First Movie Soundtrack_ 13 - Brother my Brother.mp3',
                        },
                        {
                            name: 'Tears Of Life',
                            artist: 'Pokémon The First Movie Soundtrack',
                            src: '/assets/dipocaco/sounds/music/movies_ost/Tears Of Life.mp3',
                        },
                        {
                            name: 'Pikachu\'s Rescue Adventure - Coming To The Rescue',
                            artist: 'Pokémon The Movie 2000 Soundtrack',
                            src: '/assets/dipocaco/sounds/music/movies_ost/Pikachu\'s Rescue Adventure - Coming To The Rescue.mp3',
                        },
                        {
                            name: 'Lugia\'s Song',
                            artist: 'Pokémon The Movie 2000 Soundtrack',
                            src: '/assets/dipocaco/sounds/music/movies_ost/Lugia\'s Song (Original).mp3',
                        },
                    ]
                },
                {
                    name: 'Winter',
                    enabled: true,
                    songs: [
                        {
                            name: 'Snowpoint City (Day)',
                            artist: 'Brilliant Diamond/Shining Pearl',
                            src: '/assets/dipocaco/sounds/music/xmas/1-63 Snowpoint City (Day).mp3',
                        },
                        {
                            name: 'Crystal Cave',
                            artist: 'Mystery Dungeon - Explorers of Time/Darkness',
                            src: '/assets/dipocaco/sounds/music/xmas/045 Crystal Cave.mp3',
                        },
                        {
                            name: 'Route 216 (Day)',
                            artist: 'Brilliant Diamond/Shining Pearl',
                            src: '/assets/dipocaco/sounds/music/xmas/1-62 Route 216 (Day).mp3',
                        },
                        {
                            name: 'Cinnabar Island',
                            artist: 'Heartgold/Soulsilver',
                            src: '/assets/dipocaco/sounds/music/xmas/117. Cinnabar Island.mp3',
                        },
                        {
                            name: 'Freezington',
                            artist: 'Sword/Shield',
                            src: '/assets/dipocaco/sounds/music/xmas/137. Freezington.mp3',
                        },
                        {
                            name: 'Circhester',
                            artist: 'Sword/Shield',
                            src: '/assets/dipocaco/sounds/music/xmas/81. Circhester.mp3',
                        },
                        {
                            name: 'Christmas Bash',
                            artist: 'Pokémon',
                            src: '/assets/dipocaco/sounds/music/xmas/christmas_bash.opus',
                        },
                        {
                            name: 'Nintendo Winter Mix',
                            artist: 'stellarsheik (YT)',
                            src: '/assets/dipocaco/sounds/music/xmas/winter_mix.opus',
                        },
                    ]
                },
                {
                    name: 'Pokemon X',
                    enabled: true,
                    songs: [
                        {
                            name: 'Pokémon Theme (Season Theme)',
                            artist: 'Tamara Loeffler and John Siegler',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/01. Pokémon Theme (Season Theme).mp3',
                        },
                        {
                            name: 'PokeRap',
                            artist: 'Tamara Loeffler and John Siegler',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/02. PokeRap.mp3',
                        },
                        {
                            name: 'Pokémon World (Season Theme)',
                            artist: 'John Loeffler and John Siegler',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/03. Pokemon World (Season Theme).mp3',
                        },
                        {
                            name: '2B A Master',
                            artist: 'Tamara Loeffler and Russell Velázquez',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/04. 2B A Master.mp3',
                        },
                        {
                            name: 'Together Forever',
                            artist: 'Tamara Loeffler and Ken Cummings',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/05. Together Forever.mp3',
                        },
                        {
                            name: 'Double Trouble (Team Rocket)',
                            artist: 'Tamara Loeffler, Louis Cortelezzi and Bob Mayo',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/06. Double Trouble (Team Rocket).mp3',
                        },
                        {
                            name: 'Pokémon Johto (Season Theme)',
                            artist: 'John Loeffler and John Siegler',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/07. Pokemon Johto (Season Theme).mp3',
                        },
                        {
                            name: 'PokeRap GS',
                            artist: 'John Loeffler and John Siegler',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/08. PokeRap GS.mp3',
                        },
                        {
                            name: 'Born To Be A Winner (Season Theme)',
                            artist: 'John Loeffler and John Siegler',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/09. Born To Be A Winner (Season Theme).mp3',
                        },
                        {
                            name: 'Believe in Me (Season Theme)',
                            artist: 'David Rolfe and John Siegler',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/10. Believe in Me (Season Theme).mp3',
                        },
                        {
                            name: 'I Want To Be A Hero (Season Theme)',
                            artist: 'David Rolfe and John Siegler',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/11. I Want To Be A Hero (Season Theme).mp3',
                        },
                        {
                            name: 'This Dream (Season Theme)',
                            artist: 'David Rolfe and John Siegler',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/12. This Dream (Season Theme).mp3',
                        },
                        {
                            name: 'Unbeatable (Season Theme)',
                            artist: 'David Rolfe and John Siegler',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/13. Unbeatable (Season Theme).mp3',
                        },
                        {
                            name: 'Battle Frontier (Season Theme)',
                            artist: 'John Loeffler and David Wolfert',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/14. Battle Frontier (Season Theme).mp3',
                        },
                        {
                            name: 'Hoenn PokeRap',
                            artist: 'Ethan Eubanks and Andrew Sherman',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/15. Hoenn PokeRap.mp3',
                        },
                        {
                            name: 'Best Friends',
                            artist: 'John Loeffler and David Wolfert',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/16. Best Friends.mp3',
                        },
                        {
                            name: 'Stay Together',
                            artist: 'Nini Camps and Gary Philips',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/17. Stay Together.mp3',
                        },
                        {
                            name: 'Pokémon Go!',
                            artist: 'Atsushi “TOYA” Tokuya',
                            src: '/assets/dipocaco/sounds/music/pokemon_x/18. Pokemon Go!.mp3',
                        }
                    ]
                },
                {
                    name: 'Poké & Chill',
                    enabled: true,
                    songs: [
                        {
                            name: 'Poké & Chill',
                            artist: 'GameChops',
                            src: '/assets/dipocaco/sounds/music/poke_and_chill.opus',
                        }
                    ]
                },
                {
                    name: 'DJ Pikachu',
                    enabled: true,
                    songs: [
                        {
                            name: 'Full Set',
                            artist: 'DJ Pikachu',
                            src: '/assets/dipocaco/sounds/music/dj_pikachu.mp3',
                        }
                    ]
                },
            ]
        };
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.initializePlayer(this.$props.preSelectedPlaylist ?? this.selectedPlaylistIndex);

        setInterval(() => {
            this.$forceUpdate()
        }, 950)
    },
    computed: {
        currentSong() {
            return this.activePlaylist.songs[this.currentSongIndex]
        },
        currentSongInfo() {
            return this.currentSong.name + ' | ' + this.currentSong.artist;
        },
        enabledPlaylists() {
            return this.playLists.filter(playlist => playlist.enabled);
        }
    },
    watch: {
        selectedPlaylistIndex() {
            this.playerInstance.pause();
            this.playerInstance = null;
            this.initializePlayer(this.selectedPlaylistIndex);
            this.togglePlay();
        }
    },
    methods: {
        toggleHidden() {
            this.hidden = !this.hidden;
        },
        initializePlayer(playlistIndex) {
            this.activePlaylist = this.enabledPlaylists[playlistIndex];
            this.playerInstance = new Audio();
            this.playerInstance.volume = 0.5;
            this.playerInstance.src = this.activePlaylist.songs[this.currentSongIndex].src;

            this.playerInstance.addEventListener('ended', () => {
                this.nextSong();
            });

            this.playerInstance.addEventListener('play', () => {
                this.isPlaying = true;
            });

            this.playerInstance.addEventListener('pause', () => {
                this.isPlaying = false;
            });
        },
        togglePlay() {
            if (!this.playerInstance.paused) {
                this.playerInstance.pause();
            } else {
                this.playerInstance.play();
            }
        },
        nextSong() {
            this.playerInstance.pause();

            if (this.currentSongIndex === this.activePlaylist.songs.length - 1) {
                this.currentSongIndex = 0;
            } else {
                this.currentSongIndex++;
            }

            this.playCurrentSong();
        },
        previousSong() {
            this.playerInstance.pause();

            if (this.currentSongIndex === 0) {
                this.currentSongIndex = this.activePlaylist.songs.length - 1;
            } else {
                this.currentSongIndex--;
            }

            this.playCurrentSong();
        },
        playCurrentSong() {
            this.playerInstance.src = this.currentSong.src;
            this.playerInstance.play();
        },
        getCurrentTime() {
            if (!isNaN(this.playerInstance.currentTime)) {
                return this.formatTime(this.playerInstance.currentTime);
            }
            return (0).toFixed(2); // Fallback, falls keine Audio-Instanz vorhanden ist
        },
        getDuration() {
            if (!isNaN(this.playerInstance.duration)) {
                return this.formatTime(this.playerInstance.duration);
            }
            return (0).toFixed(2); // Fallback, falls Dauer noch nicht geladen ist
        },
        formatTime(seconds) {
            const minutes = Math.floor(seconds / 60); // Ganze Minuten berechnen
            const remainingSeconds = Math.floor(seconds % 60); // Verbleibende Sekunden
            return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
        },
        getIcon() {
            if (moment().month() === 11) {
                return '☃️';
            }

            if (moment().month() === 9) {
                return '🎃';
            }

            return '📻';
        }
    },
};
</script>

<style scoped lang="scss">
.poca-player-wrapper {
    color: white;
    position: fixed;
    bottom: 5em;
    left: 1em;
    right: 1em;
    display: flex;
    justify-content: center;
    max-width: 90vw;
}

.poca-music-player {
    max-width: 90vw;
    margin-top: 1em;
    border: 1px solid grey;
    border-radius: 5px;
    background-color: black;
    color: white !important;

    padding: 0.75em;
}

.hidden-poca-player {
    justify-content: right;
}

.player-toggler {
    height: 3em;
    max-width: 40em;
    border: 1px solid grey;
    border-radius: 5px;
    background-color: black;
}

.player-controls {
    display: flex !important;
    align-items: stretch;
    justify-content: space-between;
    align-content: stretch;
    flex-wrap: wrap;
}
</style>
